import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useReducer,
} from "react";
import { CustomizationSpinnerContainer, Notification } from "../common/style";
import { Spinner, UncontrolledTooltip } from "reactstrap";
import { RenderCanvasElement } from "../project/style";
import { InternalsDimensionIcon } from "./style";
import { saveObjectPositions, addWall, copyItems } from "./service";
import { useParams } from "react-router-dom";
import { AppContext } from "../context";
import { ReactComponent as ArrowHead } from "../assets/img/arrow-head.svg";
import { sortGroupOrderItems } from "../project/service";
import AnnotationGenerator from "../project/helpers/annotation_generator";
import PositionHelper from "../project/helpers/position_helper";
import ThreeDCanvas from "./ThreeDCanvas";
import profileGlassShutter from "../assets/img/profile_glass_shutter.png";
import gProfileTop from "../assets/img/g_profile_top.png";
import gProfileLeft from "../assets/img/g_profile_left.png";
import gProfileRight from "../assets/img/g_profile_right.png";
import gProfileBottom from "../assets/img/g_profile_bottom.png";
import golaProfileHorizontal from "../assets/img/gola_profile_horizotal.png";
import golaProfileVertical from "../assets/img/gola_profile_vertical.png";
import { ReactComponent as InternalIcon } from "../assets/img/internals.svg";
import { ReactComponent as MeasurementIcon } from "../assets/img/measurement.svg";
import { isMobileOnly } from "react-device-detect";
import ContactModal from "./ContactModal";
function SectionCanvas({
  selectionManager,
  historyManager,
  currentRoom,
  showShutters,
  setShowShutters,
  projectId,
  loadRoom,
  isLoading,
  isReset,
  setIsReset,
  position,
  setPosition,
  zoom,
  setZoom,
  getObjectKey,
  hoverItem,
  setHoverItem,
  isEq,
  access,
  containerRef,
  showPreview,
  projectSummary,
}) {
  const params = useParams();
  const { isRemarksOn, isExpoOn } = useContext(AppContext);
  const scrollSensitivity = 0.00025;
  const maxZoom = 3;
  const minZoom = 0.1;
  const panFactor = 0.1;
  const renderingSize = 5;
  const move = 10;
  const shiftMove = 100;
  const minMoveThreshold = 20;

  const [initialPosition, setInitialPosition] = useState({ x: 200, y: 200 });
  const selectionManagerRef = useRef(selectionManager);
  const [showRemovedShutters, setShowRemovedShutters] = useState(false);
  const [showMeasurements, setShowMeasurements] = useState(null);
  const [showLabels, setShowLabels] = useState(false);
  const [showModuleLabels, setShowModuleLabels] = useState(false);
  const [showColors, setShowColors] = useState(true);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [reviewHoverItem, setReviewHoverItem] = useState({});
  const [canvasLoading, setCanvasLoading] = useState(false);
  const [rectSelector, setRectSelector] = useState({
    active: false,
    startPos: null,
    currentPos: null,
  });
  const [annotations, setAnnotations] = useState([]);
  const [show3d, setShow3d] = useState(false);
  const [showDrilling, setShowDrilling] = useState(false);
  const [showEdges, setShowEdges] = useState(true);
  const [canvasMode, setCanvasMode] = useState("");
  // https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [showTalkToUsModal, setShowTalkToUsModal] = useState(false);
  const moveRef = useRef({
    isMouseDown: true,
    dragging: false,
    startPositions: {},
    startMousePosition: {},
  });
  const [touchState, setTouchState] = useState({
    isTouching: false,
    startPos: { x: 0, y: 0 },
    currentPos: { x: 0, y: 0 },
    touchCount: 0,
    initialDistance: 0,
    initialZoom: 1,
  });

  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

  const handleTouch = (type, e) => {
    e.preventDefault();

    if (type === "start") {
      setTouchState({
        isTouching: true,
        startPos: {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
        },
        currentPos: {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
        },
        touchCount: e.touches.length,
        initialDistance:
          e.touches.length === 2
            ? Math.hypot(
                e.touches[1].clientX - e.touches[0].clientX,
                e.touches[1].clientY - e.touches[0].clientY
              )
            : 0,
        initialZoom: zoom,
      });
    }

    if (type === "move" && touchState.isTouching) {
      const newState = {
        ...touchState,
        currentPos: {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
        },
        touchCount: e.touches.length,
      };

      // Panning
      if (e.touches.length === 1) {
        const deltaX = newState.currentPos.x - newState.startPos.x;
        const deltaY = newState.currentPos.y - newState.startPos.y;

        setPosition({
          x: position.x + deltaX,
          y: position.y + deltaY,
        });

        newState.startPos = { ...newState.currentPos };
      }

      // Pinch zoom
      if (e.touches.length === 2) {
        const currentDistance = Math.hypot(
          e.touches[1].clientX - e.touches[0].clientX,
          e.touches[1].clientY - e.touches[0].clientY
        );

        if (touchState.initialDistance > 0) {
          const scale = currentDistance / touchState.initialDistance;
          setZoom(clamp(touchState.initialZoom * scale, 0.1, 3));
        }
      }

      setTouchState(newState);
    }

    if (type === "end") {
      setTouchState({
        isTouching: false,
        startPos: { x: 0, y: 0 },
        currentPos: { x: 0, y: 0 },
        touchCount: 0,
        initialDistance: 0,
        initialZoom: 1,
      });
    }
  };

  const handlesImage = {
    g_profile: {
      top: gProfileTop,
      left: gProfileLeft,
      right: gProfileRight,
      bottom: gProfileBottom,
    },
    j_profile: {
      top: gProfileTop,
      left: gProfileLeft,
      right: gProfileRight,
      bottom: gProfileBottom,
    },
    gola_profile_floor: {
      top: golaProfileHorizontal,
      left: golaProfileVertical,
      right: golaProfileVertical,
      bottom: golaProfileHorizontal,
    },
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const handleMeasurementClick = () => {
    if (showMeasurements === null) {
      setShowMeasurements("hw");
    } else if (showMeasurements === "hw") {
      setShowMeasurements("depth");
    } else if (showMeasurements === "depth") {
      setShowMeasurements("shutter");
    } else {
      setShowMeasurements(null);
    }
  };

  const getMeasurementText = () => {
    switch (showMeasurements) {
      case "hw":
        return "H & W";
      case "depth":
        return "Depth";
      case "shutter":
        return "Shutter";
      default:
        return null;
    }
  };

  useEffect(() => {
    const oldModule = selectionManagerRef.current.module;
    selectionManagerRef.current = selectionManager;
    selectionManagerRef.current["module"] = oldModule;

    generateMeasurements();
  }, [selectionManager]);

  useEffect(() => {
    const module = selectionManagerRef.current.module;

    if (module) {
      const newModule = selectionManagerRef.current.findModule(module.id);
      selectionManagerRef.current.select(newModule);
    }
  }, [currentRoom]);

  // ###################################################### SELECTION LOGIC #########################################################################

  const selectItem = (item, isShiftKey) => {
    selectionManager.toggle(item, isShiftKey);
  };
  const isAnyConditionOn = isRemarksOn || isExpoOn;
  const reviewItem = reviewHoverItem || selectionManager.selectedModule();
  const shouldBlurModule = (module) => {
    const hasRemarks = !!module.remarks;
    const hasExposedSides = module.customizations.exposed_sides.some(
      (side) => side !== null
    );

    const remarksConditionMet = isRemarksOn && hasRemarks;
    const expoConditionMet = isExpoOn && hasExposedSides;
    const shouldBlur =
      isRemarksOn || isExpoOn
        ? !(remarksConditionMet || expoConditionMet)
        : !(hasRemarks || hasExposedSides);

    return shouldBlur;
  };

  const handleClick = (target, clickType, isShiftKey, isAltKey) => {
    if (clickType === "single") {
      let finalSelection = target;

      if (!isAltKey && target.type !== "wall") {
        let commonAncestors = [];
        selectionManager.selections().forEach((sel, index) => {
          commonAncestors.push(findCommonAncestor(sel, target));
        });
        finalSelection = getClosestOptionToTarget(target, commonAncestors);
      }

      if (finalSelection.type === "room") {
        setHoverItem(null);
      } else {
        selectItem(finalSelection, isShiftKey);
      }
    } else if (clickType === "double") {
      let finalSelection = target;
      if (!isAltKey && target.type !== "wall") {
        finalSelection = findOneStepAncestor(
          selectionManager.selection(),
          target
        );
      }
      selectItem(finalSelection, isShiftKey);
    }
  };

  function getClosestOptionToTarget(target, optionList) {
    let targetAncestry = getAncestors(target);
    let closestToTarget;
    targetAncestry.forEach((ancestor) => {
      if (optionList.find((o) => isEq(o, ancestor))) {
        closestToTarget = ancestor;
        return;
      }
    });
    return closestToTarget || targetAncestry[targetAncestry.length - 1];
  }

  const findCommonAncestor = (object1, object2) => {
    let object1Ancestors = getAncestors(object1);
    let object2Ancestors = getAncestors(object2);
    var commonItems = getCommonItems(object2Ancestors, object1Ancestors);

    if (commonItems.length === 0) {
      return object2Ancestors[object2Ancestors.length - 1];
    } else if (commonItems[0] == object1) {
      return commonItems[0];
    } else
      return object2Ancestors[object2Ancestors.length - commonItems.length - 1];
  };

  const findOneStepAncestor = (object1, object2) => {
    let object1Ancestors = getAncestors(object1);
    let object2Ancestors = getAncestors(object2);
    var commonItems = getCommonItems(object2Ancestors, object1Ancestors);
    if (commonItems.length === 0) {
      return object2Ancestors[object2Ancestors.length - 1];
    } else {
      let commonItemIndex = object2Ancestors.indexOf(commonItems[0]);
      return commonItemIndex === 0
        ? object2Ancestors[0]
        : object2Ancestors[commonItemIndex - 1];
    }
  };

  const getCommonItems = (targetItems, selectionItems) => {
    if (targetItems == null || selectionItems == null) {
      return [];
    }

    let commonItems = [];
    for (var i = 0; i < targetItems.length; i++) {
      for (var j = 0; j < selectionItems.length; j++) {
        if (isEq(targetItems[i], selectionItems[j])) {
          commonItems.push(targetItems[i]);
        }
      }
    }
    return commonItems;
  };

  const getAncestors = (object) => {
    if (!object) {
      return null;
    } else if (object.type == "room") {
      return [];
    }

    let ancestors = [];
    let currentNode = object;

    while (currentNode) {
      ancestors.push(currentNode);
      currentNode = getParent(currentNode);
    }
    return ancestors;
  };

  const getParent = (object) => {
    switch (object.type) {
      case "space":
        if (object.path === "") {
          return selectionManager.findModule(object.order_item_id);
        } else {
          let parentSpacePath = getParentSpacePath(object.path);
          return selectionManager.findSpace(
            parentSpacePath,
            object.order_item_id
          );
        }
      case "partition":
        return selectionManager.findModule(object.order_item_id);
      case "shutter":
        return selectionManager.findModule(object.order_item_id);
      case "module":
        // Module is considered top level in Section preview.
        return null;
      case "group":
        return null;
    }
  };

  const getParentSpacePath = (path) => {
    return `${path.substring(0, path.lastIndexOf(","))}`;
  };

  // ###################################################### CANVAS RELATED FUNCTIONS/VARIABLES #########################################################################

  const [isDragging, setIsDragging] = useState(false);
  const [isCentering, setIsCentering] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const handleWheel = (event) => {
    event.preventDefault();
    setIsCentering(false);

    if (event.ctrlKey || event.metaKey) {
      const { deltaY } = event;
      setZoom((zoom) =>
        clamp(zoom + deltaY * scrollSensitivity * -1, minZoom, maxZoom)
      );
    } else if (event.shiftKey) {
      setPosition((prevPosition) => ({
        ...prevPosition,
        x: prevPosition.x - event.deltaY * panFactor,
      }));
    } else {
      setPosition((prevPosition) => ({
        x: prevPosition.x - event.deltaX * panFactor,
        y: prevPosition.y - event.deltaY * panFactor * -1,
      }));
    }
  };

  const handleMouseDown = (event) => {
    switch (event.button) {
      case 1:
        setIsDragging(true);
        setIsCentering(false);
        setInitialPosition({ x: position.x, y: position.y });

        setDragStart({
          x: event.clientX,
          y: event.clientY,
        });
    }
  };

  const isDraggable = (item) => {
    if (!item) {
      return false;
    }

    return (
      item.type === "group" || item.type === "wall" || item.type === "module"
    );
  };

  const handleItemSelectionForDrag = (event, object) => {
    let selections = selectionManager.selections();

    if (!selections.length) {
      // No selection yet.
      if (object.type === "wall") {
        selections = [object];
      } else {
        if (object.type === "module") {
          selections = [object];
        } else {
          if (object.order_item_id) {
            const module = selectionManager.findModule(object.order_item_id);

            if (module.group_id) {
              selections = [selectionManager.findGroup(module.group_id)];
            } else {
              selections = [module];
            }
          } else return;
        }
      }
    }

    moveRef.current.startMousePosition = {
      x: event.clientX,
      y: event.clientY,
    };
    moveRef.current.startPositions = {};

    for (let item of selections) {
      if (Array.isArray(item)) {
        item = item[0];
      }
      if (!isDraggable(item)) {
        continue;
      }
      const key = getObjectKey(item);
      moveRef.current.startPositions[key] = {
        x: item.position.x,
        y: item.position.y,
      };

      if (item.type === "group") {
        item.modules.forEach((m) => {
          const key = getObjectKey(m);
          const position = {
            x: m.position.x,
            y: m.position.y,
          };
          moveRef.current.startPositions[key] = position;
        });
      } else {
        // FIXME? Group update?
      }
    }

    moveRef.current.isMouseDown = true;
  };

  const handleItemClick = (event, object) => {
    if (event.button === 0) {
      if (object.type === "room") {
        if (!event.shiftKey) {
          setHoverItem(null);
        }

        setRectSelector({
          active: true,
          startPos: { x: event.clientX, y: event.clientY },
          currentPos: { x: event.clientX, y: event.clientY },
        });

        return;
      }

      if (!["shutter", "space", "partition", "wall"].includes(object.type)) {
        object = selectionManager.findModule(object.order_item_id);
      }

      switch (event.detail) {
        case 1: {
          if (access.customize_module) {
            handleItemSelectionForDrag(event, object);
          }

          timer.current = setTimeout(() => {
            handleClick(object, "single", event.shiftKey, event.altKey);
          }, 200);
          break;
        }
        case 2: {
          clearTimeout(timer.current);
          handleClick(object, "double", event.shiftKey, event.altKey);
          break;
        }
        default: {
          break;
        }
      }
    }

    event.stopPropagation();
  };

  const handleMouseMove = (event) => {
    if (isDragging) {
      setPosition({
        x: initialPosition.x + event.clientX - dragStart.x,
        y: initialPosition.y + dragStart.y - event.clientY,
      });
    }

    // Disables dragging of modules to change position
    return;

    const selectedItems = selectionManager.selections();

    if (moveRef.current.isMouseDown) {
      moveRef.current.dragging = true;
    }

    if (moveRef.current.dragging) {
      const deltaX = event.clientX - moveRef.current.startMousePosition.x;
      const deltaY = event.clientY - moveRef.current.startMousePosition.y;

      if (
        Math.abs(deltaX) > minMoveThreshold ||
        Math.abs(deltaY) > minMoveThreshold
      ) {
        for (let item of selectedItems) {
          const key = getObjectKey(item);

          if (moveRef.current.startPositions[key]) {
            item.position.x =
              moveRef.current.startPositions[key].x +
              (deltaX * renderingSize) / zoom;
            item.position.y =
              moveRef.current.startPositions[key].y -
              (deltaY * renderingSize) / zoom;

            if (item.type === "group") {
              item.modules.forEach((m) => {
                m.position.x =
                  moveRef.current.startPositions[getObjectKey(m)].x +
                  (deltaX * renderingSize) / zoom;
                m.position.y =
                  moveRef.current.startPositions[getObjectKey(m)].y -
                  (deltaY * renderingSize) / zoom;
              });
            } else if (item.type === "module" && item.group_id) {
              const group = selectionManager.findGroup(item.group_id);
              if (group.category === "BasicGroup") {
                const children = (group.modules || []).concat(
                  group.walls || []
                );
                group.position =
                  selectionManager.calculateGroupPosition(children);
                group.dimensions =
                  selectionManager.calculateGroupDimensions(children);
              }
            }
          }
        }

        moveRef.current.isMoved = true;

        forceUpdate();
      }
    }

    if (rectSelector.active) {
      const currentPos = { x: event.clientX, y: event.clientY };
      setRectSelector({ ...rectSelector, currentPos: currentPos });
      const canvasStartPosition = positionHelper.toCanvas(
        rectSelector.startPos
      );
      const canvasCurrentPosition = positionHelper.toCanvas(currentPos);

      let xMin = Math.min(canvasStartPosition.x, canvasCurrentPosition.x);
      let xMax = Math.max(canvasStartPosition.x, canvasCurrentPosition.x);
      let yMin = Math.min(canvasStartPosition.y, canvasCurrentPosition.y);
      let yMax = Math.max(canvasStartPosition.y, canvasCurrentPosition.y);
      selectObjectsInBounds({ xMin, xMax, yMin, yMax });
    }
  };

  const positionHelper = {
    isOverlapping: (bounds1, bounds2) => {
      return (
        bounds1.xMin < bounds2.xMax &&
        bounds2.xMin < bounds1.xMax &&
        bounds1.yMin < bounds2.yMax &&
        bounds2.yMin < bounds1.yMax
      );
    },
    toCanvas: (position) => {
      // TODO: Optimize to avoid calculating rect and other variables every time.
      const visibleDiv = visibleRange(zoom);
      const rect = containerRef.current.getBoundingClientRect();
      // Needed because of some unknown ~60px offset
      const visibleHeight = Math.min(
        rect.height,
        window.innerHeight - rect.top
      );
      const offsetDiff = rect.height - visibleHeight;

      let rel = {
        x: position.x - rect.left,
        y: rect.bottom - position.y - offsetDiff,
      };

      const rel2 = {
        x: visibleDiv.xMin + (rel.x * renderingSize) / zoom,
        y: visibleDiv.yMin + (rel.y * renderingSize) / zoom,
      };

      return rel2;
    },
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    moveRef.current.isMouseDown = false;

    if (moveRef.current.dragging) {
      if (moveRef.current.isMoved) {
        const selectedItems = selectionManager
          .selections()
          .filter((item) => isDraggable(item));

        if (selectedItems.length > 0) {
          moveObjects(selectedItems, moveRef.current.startPositions);
        }
      }

      moveRef.current.dragging = false;
      moveRef.current.startPositions = {};
      moveRef.current.startMousePosition = null;
      moveRef.current.isMoved = false;
    } else if (rectSelector.active) {
      setRectSelector({ ...rectSelector, active: false });
    }
  };

  const moveItemsByKeys = (event) => {
    event.preventDefault();

    const selectedItems = selectionManagerRef.current
      .selections()
      .filter((item) => isDraggable(item));
    const oldPositions = {};

    if (selectedItems.length > 0) {
      const mapper = {
        ArrowUp: move,
        ArrowDown: -move,
        ArrowLeft: -move,
        ArrowRight: move,
      };

      if (event.shiftKey) mapper["ArrowUp"] = shiftMove;
      if (event.shiftKey) mapper["ArrowDown"] = -shiftMove;
      if (event.shiftKey) mapper["ArrowLeft"] = -shiftMove;
      if (event.shiftKey) mapper["ArrowRight"] = shiftMove;

      for (let item of selectedItems) {
        oldPositions[getObjectKey(item)] = {
          x: item.position.x,
          y: item.position.y,
        };

        if (event.key === "ArrowLeft" || event.key === "ArrowRight")
          item.position.x = item.position.x + mapper[event.key];
        else item.position.y = item.position.y + mapper[event.key];

        if (item.type === "group") {
          item.modules.forEach((m) => {
            oldPositions[getObjectKey(m)] = {
              x: m.position.x,
              y: m.position.y,
            };

            if (event.key === "ArrowLeft" || event.key === "ArrowRight")
              m.position.x = m.position.x + mapper[event.key];
            else m.position.y = m.position.y + mapper[event.key];
          });
        } else if (item.type === "module" && item.group_id) {
          const group = selectionManager.findGroup(item.group_id);
          if (group && group.category === "BasicGroup") {
            const children = (group.modules || []).concat(group.walls || []);
            group.position = selectionManager.calculateGroupPosition(children);
            group.dimensions =
              selectionManager.calculateGroupDimensions(children);
          }
        }
      }

      forceUpdate();
      moveObjects(selectedItems, oldPositions);
    }
  };

  const sortModules = (event) => {
    event.preventDefault();
    const module = selectionManagerRef.current.activeModule();

    if (module && module.group_id) {
      const group = selectionManagerRef.current.findGroup(module.group_id);
      if (group.category === "StackedGroup") {
        selectionManagerRef.current["module"] = module;
        const groupId = group.id;
        const payload = {};
        payload["actionType"] = "reorder";
        payload["movedItemId"] = null;
        payload["sourceGroupId"] = groupId;

        function findModuleToSwift(sortPosition) {
          for (const module of group.modules)
            if (module.sort_position == sortPosition) return module;

          return null;
        }

        if (event.key === "ArrowLeft" && event.shiftKey) {
          if (module.sort_position == 1) return;

          const moduleToSwift = findModuleToSwift(module.sort_position - 1);
          payload["sortPayload"] = [
            { id: module.id, sort_position: module.sort_position - 1 },
            {
              id: moduleToSwift.id,
              sort_position: moduleToSwift.sort_position + 1,
            },
          ];
        } else if (event.key === "ArrowRight" && event.shiftKey) {
          if (module.sort_position == group.modules.length) return;

          const moduleToSwift = findModuleToSwift(module.sort_position + 1);
          payload["sortPayload"] = [
            {
              id: moduleToSwift.id,
              sort_position: moduleToSwift.sort_position - 1,
            },
            { id: module.id, sort_position: module.sort_position + 1 },
          ];
        } else return;

        setCanvasLoading(true);
        sortGroupOrderItems({
          projectId,
          groupId,
          payload,
        })
          .then(() => {
            loadRoom(currentRoom.id);
          })
          .catch(({ error }) => {
            setIsNotificationVisible(true);
            setNotificationMessage({ type: "danger", text: error });
          })
          .finally(() => {
            setCanvasLoading(false);
          });
      }
    }
  };

  let latestMoveTimestamps = {};

  const onMove = (newItems) => {
    const t = Date.now();
    const selectionKey = selectionManager.getKey();
    latestMoveTimestamps[selectionKey] = t;

    setTimeout(
      ((key) => {
        return () => {
          if (latestMoveTimestamps[key] === t) {
            saveObjectPositions({
              projectId: params.projectId,
              roomId: selectionManagerRef.current.currentRoom().id,
              items: newItems.map(({ position, type, id }) => ({
                position,
                type,
                id,
              })),
            }).catch(({ error }) => {
              setIsNotificationVisible(true);
              setNotificationMessage({
                text: "Error updating group position: " + error,
                type: "danger",
              });
            });
          }
        };
      })(selectionKey),
      500
    );
  };

  const moveObjects = (items, oldPositions) => {
    const itemsCopy = [...items];
    const newPositions = {};

    items.forEach((item) => {
      newPositions[getObjectKey(item)] = { ...item.position };
    });

    const groups = itemsCopy.filter((i) => i.type === "group");
    const modules = groups.map((e) => e.modules).flat();

    groups.forEach((g) => {
      const index = itemsCopy.findIndex((i) => i.id == g.id);
      itemsCopy.splice(index, 1);
    });

    const newItems = itemsCopy.concat(modules);
    historyManager.add("move", oldPositions, newPositions);
    onMove(newItems);
  };

  function getAllObjects({
    modules = true,
    groups = true,
    walls = true,
    groupChildren = false,
  }) {
    let objects = [];

    if (modules) {
      const items = currentRoom.modules
        .concat(currentRoom.groups.map((g) => g.modules))
        .flat()
        .filter((e) => selectionManager.isSelected(e));

      const newItems = items.map((m) => {
        if (m.is_packed) {
          const group = selectionManager.findGroup(m.group_id);

          return [group].concat(group.modules);
        } else return m;
      });

      objects = objects.concat(newItems.flat());
    }

    if (groups) {
      objects = objects.concat(
        currentRoom.groups.filter((e) => selectionManager.isSelected(e))
      );
    }

    // if (walls) {
    //   objects = objects.concat(currentRoom.walls);
    // }

    if (groupChildren) {
      const children = currentRoom.groups
        .filter((e) => selectionManager.isSelected(e))
        .map((group) => group.modules.concat(group.walls))
        .flat();
      objects = objects.concat(children);
    }

    return objects.filter((item) => item !== undefined);
  }

  function selectObjectsInBounds(selectionBounds) {
    const allObjects = getAllObjects({
      modules: true,
      groups: true,
      walls: true,
    });
    const toBeSelected = [];

    for (var i = 0; i < allObjects.length; i++) {
      const module = allObjects[i];
      const moduleBounds = {
        xMin: module.position.x,
        xMax: module.position.x + module.dimensions.width,
        yMin: module.position.y,
        yMax: module.position.y + module.dimensions.height,
      };

      if (PositionHelper.isOverlapping(selectionBounds, moduleBounds)) {
        toBeSelected.push(module);
      }
    }

    selectionManager.selectMultiple(toBeSelected);
  }

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("wheel", handleWheel, { passive: false });
      container.addEventListener("mousemove", handleMouseMove);
      container.addEventListener("mouseup", handleMouseUp);
      container.addEventListener("mousedown", handleMouseDown);
      container.addEventListener("mouseleave", handleMouseUp);
    }

    return () => {
      if (container) {
        container.removeEventListener("wheel", handleWheel);
        container.removeEventListener("mousemove", handleMouseMove);
        container.removeEventListener("mouseup", handleMouseUp);
        container.removeEventListener("mousedown", handleMouseDown);
        container.removeEventListener("mouseleave", handleMouseUp);
      }
    };
  }, [handleWheel, handleMouseMove, handleMouseUp, handleMouseDown]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    // User is possibly working on an input element. Don't apply shortcut.
    if (
      event.target instanceof HTMLInputElement ||
      event.target instanceof HTMLTextAreaElement
    )
      return;

    if (event.key === "i" || event.key === "I") {
      toggleInternals();
    } else if (event.key === "m" || event.key === "M") {
      setShowMeasurements((prevState) => {
        if (prevState === null) {
          return "hw";
        } else if (prevState === "hw") {
          return "depth";
        } else if (prevState === "depth") {
          return "shutter";
        } else if (prevState === "shutter") {
          return null;
        }
      });
    }
  };

  const handleCopy = (isCut = false) => {
    const selections = selectionManagerRef.current.selections();

    if (
      selections.length > 0 &&
      selections.every((selection) =>
        ["wall", "module", "group"].includes(selection.type)
      )
    ) {
      localStorage.setItem(
        "copiedObjects",
        JSON.stringify({
          operation: isCut ? "cut" : "copy",
          items: selections.map(({ type, id }) => ({ type, id })),
        })
      );
    }
  };

  const handlePaste = (event) => {
    const text = localStorage.getItem("copiedObjects");
    let clipboardSelections;
    try {
      clipboardSelections = JSON.parse(text);
    } catch (error) {
      return;
    }

    if (
      clipboardSelections &&
      clipboardSelections.items &&
      clipboardSelections.items.length > 0 &&
      ["cut", "copy"].includes(clipboardSelections.operation)
    ) {
      // TODO: Cut+Paste behaves like Copy+Paste for now.
      setCanvasLoading(true);

      // COPY ITEMS
      copyItems({
        projectId: params.projectId,
        roomId: selectionManagerRef.current.currentRoom().id,
        items: clipboardSelections.items,
        target: selectionManagerRef.current.activeGroup()
          ? {
              type: selectionManagerRef.current.activeGroup().type,
              id: selectionManagerRef.current.activeGroup().id,
            }
          : null,
      })
        .then((response) => {
          selectionManager.triggerLoadRoom(
            selectionManagerRef.current.currentRoom().id,
            null,
            response.copied_objects
          );
        })
        .catch(({ error }) => {
          setIsNotificationVisible(true);
          setNotificationMessage({
            text: "Error Pasting items: " + error,
            type: "danger",
          });
        })
        .finally(() => {
          setCanvasLoading(false);
        });
    }
  };

  const isSelected = (object) => {
    return selectionManager.isSelected(object);
  };

  const isRemovableSpace = (object) => {
    if (object.type !== "space") return;

    return object.path === selectionManager.selection().replaceable_space_path;
  };

  // ######################################################################### RENDERING FUNCTIONS/VARIABLES #########################################################################
  const renderLabels = (component) => {
    let renderStyle = {
      position: "absolute",
      bottom: `${
        component.type === "v_partition"
          ? component.dimensions.height / renderingSize / 2
          : component.type === "space" && component.is_drawer
          ? component.dimensions.height / renderingSize / 5
          : component.type === "shutter"
          ? component.dimensions.height / renderingSize / 2
          : component.dimensions.height / renderingSize
      }px`,
      left: `${
        component.type === "v_partition"
          ? "0"
          : component.type === "carcass"
          ? component.dimensions.width / renderingSize / 2
          : component.dimensions.width / renderingSize / 3
      }px`,
      alignContent: "center",
      textAlign: "center",
      opacity: 1,
      writingMode: `${
        component.type === "v_partition" ? "vertical-lr" : "horizontal-tb"
      }`,
      fontSize: "16px",
    };

    return (
      <div className="text-primary fw-bold" style={renderStyle}>
        {component.label}
      </div>
    );
  };

  const labels = (module) => {
    let renderStyle = {
      position: "absolute",
      bottom: `${module.dimensions.height / renderingSize / 2}px`,
      left: `${module.dimensions.width / renderingSize / 2.5}px`,
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      opacity: 1,
      fontSize: "26px",
      height: "40px",
      width: "40px",
      borderRadius: "50%",
      backgroundColor: "#000",
      // Setting a large value for now to ensure the label is shown. TODO: Move labels to a separate layer
      zIndex: "9999",
    };

    return (
      <div className="fw-bold" style={renderStyle}>
        {module.label}
      </div>
    );
  };

  function RenderNode(props) {
    return (
      <RenderCanvasElement
        renderingsize={renderingSize}
        // FIXME: Using zoom to calculate the outline slows the canvas.
        // zoom={zoom}
        className={`node`}
        {...props}
      >
        {props.children}
      </RenderCanvasElement>
    );
  }
  const shouldShowGroup = (item, type) => {
    const isGroup = type === "group";
    const modules = isGroup ? item.modules : [item];

    if (item.temp_id) return true;
    if (
      selectionManager.isSelected(item) ||
      item.id ===
        (isGroup
          ? selectionManager.activeGroup()?.id
          : selectionManager.activeModule()?.id)
    ) {
      return true;
    }

    const moduleIds = modules.map((m) => m.id);

    const selectedModules = selectionManager
      .selections()
      .filter((e) => e.type === "module");
    if (selectedModules.some((mod) => moduleIds.includes(mod.id))) {
      return true;
    }

    const selectedSpecials = selectionManager
      .selections()
      .filter((e) => ["partition", "shutter", "space"].includes(e.type));
    if (
      selectedSpecials.some((special) =>
        moduleIds.includes(special.order_item_id)
      )
    ) {
      return true;
    }

    return false;
  };

  const renderRoom = () => {
    return (
      <div>
        {currentRoom.groups.map((group, groupIndex) => {
          if (!shouldShowGroup(group, "group")) return;

          return (
            <>
              <GroupNode
                key={groupIndex}
                group={group}
                isAnyConditionOn={isAnyConditionOn}
              ></GroupNode>

              {group.modules?.map((module, moduleIndex) => (
                <>
                  <ModuleNode
                    key={moduleIndex}
                    module={module}
                    isAnyConditionOn={isAnyConditionOn}
                  ></ModuleNode>
                  {showMeasurements == "depth" &&
                    renderDepthMeasurements(module)}
                </>
              ))}

              {group.walls?.map((wall, wallIndex) => (
                <WallNode
                  key={wallIndex}
                  wall={wall}
                  isAnyConditionOn={isAnyConditionOn}
                ></WallNode>
              ))}
            </>
          );
        })}

        {currentRoom.modules?.map((module, moduleIndex) => {
          if (!shouldShowGroup(module, "module")) return;

          return (
            <>
              <ModuleNode
                key={moduleIndex}
                module={module}
                isAnyConditionOn={isAnyConditionOn}
              />
              {showMeasurements == "depth" && renderDepthMeasurements(module)}
            </>
          );
        })}
      </div>
    );
  };

  function renderDragSelection() {
    if (rectSelector.active) {
      const rect = containerRef.current.getBoundingClientRect();
      const left =
        Math.min(rectSelector.startPos.x, rectSelector.currentPos.x) - rect.x;
      const top =
        Math.min(rectSelector.startPos.y, rectSelector.currentPos.y) - rect.y;

      return (
        <div
          className="rect-selector"
          style={{
            left: left,
            top: top,
            width: Math.abs(
              rectSelector.currentPos.x - rectSelector.startPos.x
            ),
            height: Math.abs(
              rectSelector.startPos.y - rectSelector.currentPos.y
            ),
            outline: "3px solid blue",
          }}
        ></div>
      );
    }
  }

  function GroupNode({ group, isAnyConditionOn }) {
    if (group.temp_id) {
      return;
    }

    return (
      <RenderNode
        object={group}
        className={`group-node bg-light-grey ${isSelected(group) && "active"} ${
          isEq(hoverItem, group) && "hover"
        }  ${isAnyConditionOn ? "blurred-light" : ""}`}
        style={{ pointerEvents: "none", zIndex: "-2" }}
      ></RenderNode>
    );
  }

  function WallNode({ wall, isAnyConditionOn }) {
    return (
      <RenderNode
        object={wall}
        className={`wall-node ${isSelected(wall) && "active"} ${
          isEq(hoverItem, wall) && "hover"
        } ${isAnyConditionOn ? "blurred-light" : ""}`}
        onMouseDown={(event) => {
          clickHandler(event, wall);
        }}
        onMouseEnter={() => {
          setHoverItem(wall);
        }}
        onMouseLeave={() => {
          setHoverItem(null);
        }}
      ></RenderNode>
    );
  }

  function onModuleHover(module) {
    let selections = selectionManagerRef.current.selections();
    let selectedObjectSiblings = false;

    if (
      selections.some((selection) => selection.group_id === module.group_id)
    ) {
      selectedObjectSiblings = true;
    }

    if (!selectedObjectSiblings && module.group_id) {
      const group = selectionManager.findGroup(module.group_id);

      if (group) {
        setHoverItem(group);
      }
    } else if (selectedObjectSiblings && module.group_id) {
      const parentGroup = selectionManager.findGroup(module.group_id);

      if (parentGroup) {
        const siblingModules = parentGroup.modules.filter(
          (m) => m.id === module.id
        );
        if (Array.isArray(siblingModules)) {
          setHoverItem(siblingModules[0]);
        } else {
          setHoverItem(siblingModules);
        }
      }
    } else {
      setHoverItem(module);
    }
  }

  function onSelectionHover(selection, module) {
    if (selection.type == "shutter") {
      if (
        module.template.shutters.some(
          (selection) => selection.order_item_id === module.id
        )
      ) {
        setHoverItem(selection);
      }
    } else if (selection.type == "partition") {
      if (
        module.template.partitions.some(
          (selection) => selection.order_item_id === module.id
        )
      ) {
        setHoverItem(selection);
      }
    } else if (selection.type === "space") {
      if (selectionManager.selection().is_root_space) {
        setHoverItem(selection);
        return;
      }
    }
  }

  function ModuleNode({ module, isAnyConditionOn }) {
    const isStale = projectSummary.stale_order_item_ids?.includes(module.id);

    return (
      <RenderNode
        object={module}
        className={`module-node ${isSelected(module) && "active"} ${
          isEq(hoverItem, module) && "hover"
        } ${
          isAnyConditionOn && shouldBlurModule(module) ? "blurred-light" : ""
        }`}
      >
        {module.template && !isStale && (
          <>
            <ComponentNode
              className="base-component"
              component={module.template.base_component}
              onMouseDown={(event) =>
                clickHandler(event, module.template.base_component)
              }
            ></ComponentNode>
            <SpaceNode
              className="root-space"
              space={module.template.root_space}
              module={module}
            ></SpaceNode>
            {
              <div className="partitions">
                {module.template.partitions.map((partition, partitionIndex) => (
                  <PartitionNode
                    key={partitionIndex}
                    partition={partition}
                    module={module}
                  ></PartitionNode>
                ))}
              </div>
            }
            {showShutters && (
              <div className="shutters">
                {module.template.shutters.map((shutter, shutterIndex) => (
                  <ShutterNode
                    className="shutter-node"
                    key={shutterIndex}
                    shutter={shutter}
                    module={module}
                  ></ShutterNode>
                ))}
                {showModuleLabels && labels(module)}
              </div>
            )}
          </>
        )}
        {showModuleLabels && labels(module)}

        {isStale && (
          <>
            <div
              className="position-absolute h-100 w-100 opacity-25 bg-black"
              style={{
                zIndex: 10,
              }}
              id={`stale-module-${module.id}`}
            >
              <div className="position-absolute top-50 start-50 translate-middle text-center">
                <i
                  className="fa-solid fa-circle-exclamation text-white fs-1"
                  style={{ fontSize: "3rem" }}
                />
              </div>
            </div>
            <UncontrolledTooltip target={`stale-module-${module.id}`} placement="bottom">
              Preview is outdated. Refresh using the header.
            </UncontrolledTooltip>
          </>
        )}
      </RenderNode>
    );
  }

  function PartitionNode({ partition, module }) {
    return (
      <ComponentNode
        component={partition.component}
        onMouseDown={(event) => clickHandler(event, partition)}
        onMouseEnter={() => {
          if (
            selectionManager.selection() &&
            selectionManager.selection().type == "partition"
          ) {
            onSelectionHover(partition, module);
          }
        }}
        onMouseLeave={() => {
          setHoverItem(null);
        }}
        className={`partition-node ${isSelected(partition) && "active"}`}
      />
    );
  }

  function ShutterNode({ shutter, module }) {
    if (
      shutter.is_removed &&
      !showRemovedShutters &&
      !module.has_profile_shutter
    )
      return;

    return (
      <ComponentNode
        component={shutter.component}
        hasProfileShutter={module.has_profile_shutter}
        hasCNC={shutter.cnc_type != "none"}
        hasPattern={shutter.pattern_type != "none"}
        handle={module.handle}
        onMouseDown={(event) => clickHandler(event, shutter)}
        onMouseEnter={() => {
          if (
            selectionManager.selection() &&
            selectionManager.selection().type == "shutter"
          ) {
            onSelectionHover(shutter, module);
          }
        }}
        onMouseLeave={() => {
          setHoverItem(null);
        }}
        className={`${isSelected(shutter) && "active"}`}
        fromShutter={true}
      />
    );
  }

  function SpaceNode({ space, widthCount = -1, heightCount = -1, module }) {
    if (!space) return;
    if (space.width) widthCount++;
    if (space.height) heightCount++;

    return (
      <RenderNode
        object={space}
        onMouseDown={(event) => clickHandler(event, space)}
        onMouseEnter={() => {
          if (
            selectionManager.selection() &&
            selectionManager.selection().type == "space"
          ) {
            onSelectionHover(space, module);
          }
        }}
        onMouseLeave={() => {
          setHoverItem(null);
        }}
        className={`space-node ${
          isSelected(space) && "active"
        } ${isRemovableSpace("replaceable-space")}`}
        key={space}
      >
        {space.children &&
          space.children.map((childSpace, spaceIndex) => (
            <SpaceNode
              key={spaceIndex}
              space={childSpace}
              widthCount={widthCount}
              heightCount={heightCount}
              module={module}
            ></SpaceNode>
          ))}
        {space.is_drawer && (
          <div className="h-100 pattern border border-black">
            {showLabels && renderLabels(space)}
          </div>
        )}
        {showMeasurements && !space.is_root_space && (
          <>
            {space.width && (
              <div
                className="d-flex position-absolute"
                style={{
                  top: `${widthCount * 20}px`,
                  left: "12px",
                  width: space.dimensions["width"] / renderingSize - 15,
                  color: "blue",
                }}
              >
                <InternalsDimensionIcon className="w-100" dimension={"width"} />
                <div
                  style={{ fontSize: "10px" }}
                  className="w-100 d-flex justify-content-center"
                >
                  <span>{space.width}</span>
                </div>
              </div>
            )}
            {space.height && (
              <div
                className="d-flex position-absolute"
                style={{
                  top: "6px",
                  left: `${heightCount * 20}px`,
                  height: space.dimensions["height"] / renderingSize - 9,
                  color: "blue",
                }}
              >
                <InternalsDimensionIcon
                  className="h-100"
                  dimension={"height"}
                />
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ writingMode: "vertical-rl", fontSize: "10px" }}
                >
                  <span style={{ transform: "rotate(180deg)" }}>
                    {space.height}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      </RenderNode>
    );
  }

  function ComponentNode(props) {
    const component = props.component;
    const componentIndex = 0;
    const hasProfileShutter = props.hasProfileShutter;
    const hasCNC = props.hasCNC;
    const hasPattern = props.hasPattern;
    return (
      <RenderNode
        object={component}
        className={`component-node`}
        key={componentIndex}
        {...props}
      >
        {props.handle?.show &&
          (() => {
            const side =
              props.handle.config.shutter_directions[
                component.sequence_number - 1
              ];
            return (
              <div
                className="position-absolute d-flex"
                style={{
                  [side]: 0,
                  height: ["top", "bottom"].includes(side)
                    ? `${props.handle.config.offset / renderingSize}px`
                    : "100%",
                  width: ["top", "bottom"].includes(side)
                    ? "100%"
                    : `${props.handle.config.offset / renderingSize}px`,
                }}
              >
                <img
                  src={handlesImage[props.handle.type][side]}
                  className="w-100 h-100"
                />
              </div>
            );
          })()}
        {component.panels.map((panel, panelIndex) => (
          <>
            <PanelNode
              key={panelIndex}
              panel={panel}
              componentType={component.type}
              componentIdentifier={component.identifier}
              hasProfileShutter={hasProfileShutter}
              hasCNC={hasCNC}
              hasPattern={hasPattern}
            ></PanelNode>
            {showMeasurements === "shutter" && props.fromShutter && (
              <>
                {panel.dimensions.width && (
                  <div
                    className="d-flex position-absolute align-items-end"
                    style={{
                      bottom: 5,
                      left: "6px",
                      width: panel.dimensions["width"] / renderingSize - 15,
                      color: "blue",
                    }}
                  >
                    <div
                      style={{ fontSize: "10px" }}
                      className="w-100 d-flex justify-content-center align-items-center"
                    >
                      <span>{panel.dimensions.width}</span>
                    </div>
                    <InternalsDimensionIcon
                      className="ms-1 w-100"
                      dimension={"width"}
                    />
                  </div>
                )}

                {panel.dimensions.height && (
                  <div
                    className="d-flex position-absolute"
                    style={{
                      top: "2px",
                      left: 5,
                      height: panel.dimensions["height"] / renderingSize - 9,
                      color: "blue",
                    }}
                  >
                    <InternalsDimensionIcon
                      className="h-100"
                      dimension={"height"}
                    />
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        writingMode: "vertical-rl",
                        fontSize: "10px",
                      }}
                    >
                      <span>{panel.dimensions.height}</span>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        ))}
        {showLabels && renderLabels(component)}
      </RenderNode>
    );
  }

  function PanelNode({
    panel,
    componentType,
    componentIdentifier,
    hasProfileShutter,
    hasCNC,
    hasPattern,
  }) {
    let style = {};

    let backgroundColor =
      componentType === "shutter" && !hasProfileShutter ? "#d9d9d9" : "none";

    let border = "1px solid black";
    let backgroundImage =
      componentType === "shutter" && hasProfileShutter
        ? `url(${profileGlassShutter})`
        : "none";

    let backgroundRepeat =
      componentType === "shutter" && hasProfileShutter ? "no-repeat" : "none";

    let backgroundSize =
      componentType === "shutter" && hasProfileShutter ? "100% 100%" : "none";

    let boxShadow = "none";
    let zIndex = 0;

    if (panel.front_laminate && showColors && !hasProfileShutter) {
      if (panel.front_laminate.image_url) {
        backgroundImage = `url("${panel.front_laminate.image_url}")`;
        backgroundRepeat = "repeat";
        backgroundSize = `${
          panel.front_laminate.image_width / renderingSize
        }px ${panel.front_laminate.image_height / renderingSize}px`;
      } else if (panel.front_laminate.color_code) {
        backgroundColor = panel.front_laminate.color_code;
      }
    } else {
      // No laminate applied.
      backgroundColor: "#d9d9d9";
    }

    if (panel.orientation != "surface") {
      // Edge
      if (componentIdentifier === "removable_shelf") {
        border = "1px dashed black";
      } else {
        // Fixed partition - fill with black.
        backgroundColor = "black";
      }
    } else {
      if (panel.identifier == "backsheet") {
        zIndex = -1;
      }
    }

    style = {
      border: border,
      backgroundColor: backgroundColor,
      backgroundImage: backgroundImage,
      backgroundRepeat: backgroundRepeat,
      backgroundSize: backgroundSize,
      boxShadow: boxShadow,
      zIndex: zIndex,
    };

    return (
      <RenderNode
        object={panel}
        className="panel-node"
        style={style}
        key={panel.uniq_id}
      >
        {(hasCNC || hasPattern) && componentType === "shutter" && (
          <div className="position-absolute top-0 end-0 d-flex flex-column align-items-end gap-1">
            {hasCNC && (
              <div className="bg-dark bg-opacity-50 text-white px-2 fw-bold">
                CNC
              </div>
            )}
            {hasPattern && (
              <div className="bg-dark bg-opacity-50 text-white px-1 small fw-bold">
                PATTERN
              </div>
            )}
          </div>
        )}
      </RenderNode>
    );
  }

  // ######################################################################### EVENT HANDLING #########################################################################

  let timer = useRef();

  const clickHandler = (event, object) => {
    handleItemClick(event, object);
  };

  const centerCanvasOnPosition = (x, y, zoomValue) => {
    const rect = containerRef.current.getBoundingClientRect();

    // Needed because the height of the div extends off screen
    const visibleHeight = Math.min(rect.height, window.innerHeight - rect.top);

    const newPosition = {
      x: -1 * ((x * zoomValue) / renderingSize - rect.width / 2),
      y: -1 * ((y * zoomValue) / renderingSize - visibleHeight / 2),
    };

    setIsCentering(true);
    if (newPosition.x && newPosition.y) setPosition(newPosition);
  };

  const visibleRange = (zoomAmount) => {
    const rect = containerRef.current.getBoundingClientRect();
    // Needed because the height of the div extends off screen
    const visibleHeight = Math.min(rect.height, window.innerHeight - rect.top);

    const range = {
      xMin: (-1 * position.x * renderingSize) / zoomAmount,
      yMin:
        ((rect.height - visibleHeight) * renderingSize) / zoomAmount +
        (-1 * position.y * renderingSize) / zoomAmount,
      xMax: ((-1 * position.x + rect.width) * renderingSize) / zoomAmount,
      yMax: ((-1 * position.y + visibleHeight) * renderingSize) / zoomAmount,
    };
    return range;
  };

  const isItemVisible = (itemBounds, rect) => {
    const isXPartiallyVisible =
      itemBounds.xMax > rect.xMax && itemBounds.xMin < rect.xMax;
    const isYPartiallyVisible =
      itemBounds.yMax > rect.yMin && itemBounds.yMin < rect.yMax;

    return isXPartiallyVisible && isYPartiallyVisible;
  };

  const getBounds = (position, dimensions) => {
    return {
      xMin: position?.x,
      xMax: position?.x + dimensions.width / renderingSize,
      yMin: position?.y,
      yMax: position?.y + dimensions.height / renderingSize,
    };
  };

  const resetItem = () => {
    if (isReset) {
      let items = selectionManager.selection();

      if (items) {
        // let zoomValue = zoom;
        // if (zoom > 1.5 || zoom < 0.3) {
        //   setZoom(0.5);
        //   zoomValue = 0.5;
        // }
        let itemPosition;
        let itemDimensions;

        const visibleRangeResult = visibleRange(zoom);

        if (items.group_id) {
          let group = currentRoom.groups.find(
            (grp) => grp.id === items.group_id
          );

          if (group) {
            itemPosition = group.position;
            itemDimensions = group.dimensions;

            if (
              !isItemVisible(
                getBounds(itemPosition, itemDimensions),
                visibleRangeResult
              )
            ) {
              centerCanvasOnPosition(
                group.position?.x + group.dimensions.width / 2,
                group.position?.y + group.dimensions.height / 2,
                zoom
              );
            }
          }
        } else {
          itemPosition = items.position;
          itemDimensions = items.dimensions;

          if (
            !isItemVisible(
              getBounds(itemPosition, itemDimensions),
              visibleRangeResult
            )
          ) {
            centerCanvasOnPosition(
              items.position?.x + items.dimensions.width / 2,
              items.position?.y + items.dimensions.height / 2,
              zoom
            );
          }
        }
        setIsReset(false);
      }
    }
  };

  useEffect(() => {
    resetItem();
  }, [isReset]);

  useEffect(() => {
    if (showMeasurements == "hw") {
      generateMeasurements();
    }
  }, [showMeasurements]);

  // ########################################################################################

  const toggleInternals = () => {
    if (selectionManager.activeModule()) {
      selectionManager.select(selectionManager.activeModule());
    }

    setShowShutters((prevState) => !prevState);
    setShowRemovedShutters(false);
  };

  function generateMeasurements() {
    const eligibleObjects = getAllObjects({
      groupChildren: true,
      walls: false,
    });
    const generator = new AnnotationGenerator(eligibleObjects);
    generator.process();
    setAnnotations(generator.getValidAnnotations());
  }

  // TODO. Move to a component.
  function renderMeasurements() {
    return (
      <div className="measurements">
        {annotations.map((annotation) => {
          const style = {
            left: `${annotation.position.x / renderingSize}px`,
            bottom: `${annotation.position.y / renderingSize}px`,
          };

          if (annotation.isHeight()) {
            style.height = `${annotation.dimensions.height / renderingSize}px`;
          } else {
            style.width = `${annotation.dimensions.width / renderingSize}px`;
          }

          return (
            <div
              className={`measurement-item ${
                annotation.isHeight() && "height"
              } ${annotation.isAlt && "flipped"} ${
                !annotation.isHeight() && "width"
              }`}
              style={style}
            >
              <div className="text">{annotation.text}</div>
              <div className="marker">
                <ArrowHead
                  class={`arrow ${annotation.isHeight() ? "up" : "left"}`}
                ></ArrowHead>
                <div className="line"></div>
                <ArrowHead
                  className={`arrow ${
                    annotation.isHeight() ? "down" : "right"
                  }`}
                ></ArrowHead>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  function renderDepthMeasurements(module) {
    return (
      <>
        <div
          className="measurement-depth position-absolute px-3"
          style={{
            left: `${
              (module.position.x + module.dimensions.width / 2) / renderingSize
            }px`,
            bottom: `${(module.position.y - 250) / renderingSize}px`,
            textAlign: "center",
            position: "absolute",
            transform: "translateX(-50%)",
          }}
        >
          {module.dimensions.depth}{" "}
        </div>
      </>
    );
  }

  function getOutlineForItem(type) {
    if (type == "module" || type == "wall") {
      return "#0000CC";
    } else if (type == "group") {
      return "#CC0000";
    } else {
      return "#00AA00";
    }
  }

  function renderSelectionBorders() {
    const selectionItems = selectionManager.selections();

    if (!selectionItems.length || selectionManager.selectedGroup()) {
      return;
    }

    return (
      <div className="selection-borders">
        {selectionItems.map((item) => {
          let position = item.position;
          let dimensions = item.dimensions;
          let outlineColor = getOutlineForItem(item.type);

          if (
            item.type === "shutter" ||
            item.type === "partition" ||
            item.type === "space"
          ) {
            // For internals, the position will be relative to the module.
            // Convert them to absolute room position by adding the module position.
            let module = null;

            if (selectionItems.length === 1) {
              module = selectionManager.activeModule();
            } else {
              module = selectionManager.findModule(item.order_item_id);
            }

            // For component based nodes, the position has to be derived from the component.
            const relPosition =
              item.type === "space"
                ? item.abs_position
                : item.component.position;

            position = {
              x: module.position.x + relPosition.x,
              y: module.position.y + relPosition.y,
            };
          }

          return (
            <div
              className="selection"
              style={{
                outline: `${3 / zoom}px solid ${outlineColor}`,
                left: `${position.x / renderingSize}px`,
                bottom: `${position.y / renderingSize}px`,
                height: `${dimensions.height / renderingSize}px`,
                width: `${dimensions.width / renderingSize}px`,
              }}
            ></div>
          );
        })}
      </div>
    );
  }

  function renderHoverBorder() {
    if (!hoverItem || !selectionManager.selections()) {
      return;
    }

    // Don't hover the contextual parent since it will show double border.
    if (
      selectionManager.activeModule() === hoverItem ||
      selectionManager.activeGroup() === hoverItem
    ) {
      return;
    }

    let position = hoverItem.position;
    let outlineColor = getOutlineForItem(hoverItem.type);
    if (
      hoverItem.type === "shutter" ||
      hoverItem.type === "partition" ||
      hoverItem.type === "space"
    ) {
      let module = selectionManager.findModule(hoverItem.order_item_id);

      const relPosition =
        hoverItem.type === "space"
          ? hoverItem.abs_position
          : hoverItem.component.position;

      position = {
        x: module.position.x + relPosition.x,
        y: module.position.y + relPosition.y,
      };
    }

    return (
      <div
        className="hover-border"
        style={{
          outline: `${2 / zoom}px solid ${outlineColor}`,
          left: `${position.x / renderingSize}px`,
          bottom: `${position.y / renderingSize}px`,
          height: `${hoverItem.dimensions.height / renderingSize}px`,
          width: `${hoverItem.dimensions.width / renderingSize}px`,
        }}
      ></div>
    );
  }

  return !currentRoom ? (
    <div className="position-relative">
      <CustomizationSpinnerContainer top="200px" left="40%">
        <Spinner />
      </CustomizationSpinnerContainer>
    </div>
  ) : (
    <>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}
      {!isMobileOnly && (
        <div
          className="canvas-actions ms-3"
          style={{
            right: "auto",
          }}
        >
          <div className="toggles">
            <div
              id="toggle-internals"
              className={`toggle-item ${!showShutters && "active"}`}
              onClick={() => toggleInternals()}
            >
              <InternalIcon></InternalIcon>
            </div>
            <UncontrolledTooltip target={`toggle-internals`} placement="bottom">
              Internals (I)
            </UncontrolledTooltip>
            <div
              id="toggle-measurements"
              className={`toggle-item ${
                showMeasurements && "active"
              } position-relative`}
              onClick={handleMeasurementClick}
            >
              <MeasurementIcon></MeasurementIcon>
              {showMeasurements !== null && (
                <div className="mode">{getMeasurementText()}</div>
              )}
            </div>
            <UncontrolledTooltip target={`toggle-measurements`} placement="top">
              Measurements (M)
            </UncontrolledTooltip>
            <div
              id="toggle-removed-shutters"
              className={`toggle-item ${showRemovedShutters && "active"} ${
                !showShutters && "disabled"
              }`}
              onClick={() => setShowRemovedShutters(!showRemovedShutters)}
            >
              <i className="fa fa-eye"></i>
            </div>
            <UncontrolledTooltip
              target={`toggle-removed-shutters`}
              placement="bottom"
            >
              Toggle removed shutters
            </UncontrolledTooltip>
            <div
              id="toggle-labels"
              className={`toggle-item ${showModuleLabels && "active"}`}
              onClick={() => setShowModuleLabels(!showModuleLabels)}
            >
              <i className="fa-solid fa-tags"></i>{" "}
            </div>
            <UncontrolledTooltip target={`toggle-labels`} placement="bottom">
              Labels
            </UncontrolledTooltip>
            <div
              id="toggle-colors"
              className={`toggle-item ${showColors && "active"}`}
              onClick={() => setShowColors(!showColors)}
            >
              <i className="fa-solid fa-palette"></i>{" "}
            </div>
            <UncontrolledTooltip target={`toggle-colors`} placement="bottom">
              Colors
            </UncontrolledTooltip>
            {show3d && (
              <>
                <div
                  id="toggle-colors"
                  className={`toggle-item ${showEdges && "active"}`}
                  onClick={() => setShowEdges(!showEdges)}
                >
                  <i className="fas fa-border-style"></i>{" "}
                </div>
                <UncontrolledTooltip target={`toggle-colors`} placement="bottom">
                  Show Edges
                </UncontrolledTooltip>
              </>
            )}
          </div>
        </div>
      )}
      <div
        className="position-absolute z-3"
        style={{ bottom: "9rem", right: "1rem" }}
      >
        <div className="toggle-container">
          <div
            className={`toggle-button ${!show3d && "active"}`}
            onClick={() => {
              setShow3d(false);
              setCanvasMode("");
            }}
          >
            2D
          </div>
          <div
            className={`toggle-button ${show3d && "active"}`}
            onClick={() => {
              setShow3d(true);
              setCanvasMode("rotate");
            }}
          >
            3D
          </div>
        </div>
      </div>
      {!isMobileOnly &&
        projectSummary.owner.org_status &&
        projectSummary.owner.org_status == "prospect" && (
          <div
            className="position-absolute end-0 p-2 d-flex align-items-center justify-content-center text-white fw-bold p-1 rounded cursor-pointer bg-primary"
            onClick={() => setShowTalkToUsModal(true)}
            style={{
              fontSize: "1.5rem",
              zIndex: 25,
              cursor: "pointer",
              bottom: "3rem",
            }}
          >
            <i className="fa-solid fa-phone me-2"></i>
            <span>Talk to us</span>
          </div>
        )}
      <ContactModal
        isOpen={showTalkToUsModal}
        toggle={() => setShowTalkToUsModal(false)}
      />
      {isMobileOnly && (
        <div
          className="canvas-actions position-absolute z-3 justify-content-center w-100"
          style={{ bottom: "100px", top: "auto", paddingTop: 0 }} // override top position
        >
          <div className="toggles">
            <div
              id="toggle-internals"
              className={`toggle-item ${!showShutters && "active"}`}
              onClick={() => toggleInternals()}
            >
              <InternalIcon />
            </div>
            <UncontrolledTooltip target="toggle-internals" placement="top">
              Internals (I)
            </UncontrolledTooltip>

            <div
              id="toggle-measurements"
              className={`toggle-item ${
                showMeasurements && "active"
              } position-relative`}
              onClick={handleMeasurementClick}
            >
              <MeasurementIcon />
              {showMeasurements !== null && (
                <div className="mode">{getMeasurementText()}</div>
              )}
            </div>
            <UncontrolledTooltip target="toggle-measurements" placement="top">
              Measurements (M)
            </UncontrolledTooltip>
          </div>
        </div>
      )}

      {!show3d ? (
        <div
          className="fh position-relative d-flex justify-content-center align-items-center overflow-hidden room-canvas-container"
          id="canvas-div"
          ref={containerRef}
          tabIndex="0"
          style={{
            cursor: "default",
            ...(isMobileOnly ? { maxHeight: "350px", bottom: 0 } : {}),
            overflow: "hidden",
            touchAction: "none",
            userSelect: "none",
          }}
          onMouseDown={(event) => clickHandler(event, { type: "room" })}
          onTouchStart={(e) => handleTouch("start", e)}
          onTouchMove={(e) => handleTouch("move", e)}
          onTouchEnd={(e) => handleTouch("end", e)}
        >
          <div
            className={`position-absolute d-flex justify-content-left border ${
              isCentering && "canvas-container-centering"
            }`}
            style={{
              left: `${position.x}px`,
              bottom: `${position.y}px`,
              transform: `scale(${zoom}) translateZ(0)`,
              border: "2px solid red",
            }}
          >
            {renderRoom()}
            {showMeasurements == "hw" && renderMeasurements()}
            {renderSelectionBorders()}
            {renderHoverBorder()}
          </div>
          {renderDragSelection()}
        </div>
      ) : (
        <div className="canvas-wrapper">
          <ThreeDCanvas
            currentRoom={currentRoom}
            showShutters={showShutters}
            showRemovedShutters={showRemovedShutters}
            canvasMode={canvasMode}
            showDrilling={showDrilling}
            showEdges={showEdges}
            mode="table"
            selectionManager={selectionManager}
          ></ThreeDCanvas>
        </div>
      )}
    </>
  );
}

export default SectionCanvas;
